import React from 'react';
import { isNLD_OR_LL } from 'common/constants/app.constants';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';

export const ServiceDetailsSection = ({ rowData }) => {
  const options = [
    { id: 'UNMANAGED', displayName: 'Unmanaged Services' },
    { id: 'MANAGED', displayName: 'Managed Services' }
  ];
  const getServiceTypeValue = (id) => {
    return options.filter((option) => option.id === id)[0] || options[0];
  };

  return (
    <>
      <div className="select_info">
        <div className="text">Service Type </div>
        <div className="tooltip_wrap">
          <span className="material-icons-outlined">info</span>
          <div className="tooltip">
            <div className="tooltip_content">Service Type</div>
          </div>
        </div>
      </div>
      <div className="radio_box">
        <RadioGroup options={options} value={getServiceTypeValue(rowData.service)} disabled />
      </div>
      {!isNLD_OR_LL() && (
        <div className="row">
          <div className="flg-lg-6 flg-md-6">
            <Input name="CPE" type="text" value={rowData.cpe ? rowData.cpe : 'N/A'} label="Common Platform Enumeration (CPE)" required disabled />
          </div>
          <div className="flg-lg-6 flg-md-6">
            <Input name="CPE SPE" type="text" value={rowData.cpeSpecification ? rowData.cpeSpecification : 'N/A'} label="CPE Specification" required disabled />
          </div>
        </div>
      )}
    </>
  );
};
